import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {

    components: { 'slick-carousel' : VueSlickCarousel },
    props: [],
    data: () => {
        return {
            navigation: '',
            parceirosModalContent: '',
            certificacoesModalContent: '',
            certificacoesSlidersContent: [],
            certificacoesModalElement: null,
            showParceirosModal: false,
            showCertificacoesModal: false,
            leftMenuIsOpen: false,

            slickSettings: {
                arrows: true,
                dots: true,
                draggable: true,
                slidesToShow: 1,
                infinite: true,
                speed: 300,
            }
        }
    },

    watch: {
        leftMenuIsOpen: function (open) {
            let bodyElement = document.getElementsByTagName('body')[0];
            if (open === true) {
                bodyElement.classList.add('modal-open');
            } else {
                bodyElement.classList.remove('modal-open');
            }
        },
        navigation: function (menu) {

            if (menu === '') {
                return;
            }

            setTimeout(() => {
                let navlinkMobile = document.getElementById('left-menu-holder').querySelectorAll('a.nav-link');
                navlinkMobile.forEach((link) => {
                    link.addEventListener('click', () => {
                        this.leftMenuIsOpen = false;
                    })
                })
            })
        }
    },

    beforeMount() {

    },

    mounted() {

        let menuComponent = document.getElementsByClassName('container-with-component-class-top-menu')[0];
        let parceirosModalComponent = document.getElementsByClassName('container-with-component-class-parceiros-modal')[0];
        let certificacoesModalComponent = document.getElementsByClassName('container-with-component-class-certificacoes-modal')[0];

        if (menuComponent !== undefined) {
            this.navigation = menuComponent.outerHTML;
            menuComponent.remove()
        }
        if (parceirosModalComponent !== undefined) {
            this.parceirosModalContent = parceirosModalComponent.innerHTML;
            parceirosModalComponent.remove()
        }

        let modalParceirosTrigger = document.querySelector('a[href="#parceiros"]');
            modalParceirosTrigger.addEventListener('click', () => {
                this.showParceirosModal = true;
            })

        if (certificacoesModalComponent !== undefined) {
            let sliders = certificacoesModalComponent.querySelectorAll('.slick-slide:not(.slick-cloned)');
            if (sliders.length > 0) {
                sliders.forEach((slide) => {
                    this.certificacoesSlidersContent.push(slide.querySelector('.inside-area').innerHTML);
                });
            }
            certificacoesModalComponent.remove()
        }

        let modalCertificacoesTrigger = document.querySelector('a[href="#certificacoes"]');
            modalCertificacoesTrigger.addEventListener('click', () => {
                this.showCertificacoesModal = true;
            })

    },
    methods: {
        toggleLeftMenu: function (){
            this.leftMenuIsOpen = !this.leftMenuIsOpen;
        }
    }
}
